import { render } from "./NoBookingsContent.vue?vue&type=template&id=6291507c&scoped=true"
import script from "./NoBookingsContent.vue?vue&type=script&lang=js"
export * from "./NoBookingsContent.vue?vue&type=script&lang=js"

import "./NoBookingsContent.vue?vue&type=style&index=0&id=6291507c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6291507c"]])

export default __exports__